var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitetwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903",
    transform: "translate(-2994 -6616)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1058",
    "data-name": "Rectangle 1058",
    width: 24,
    height: 24,
    transform: "translate(2994 6616)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M101.324,100h3.361l-7.342,8.391,8.637,11.419H99.217l-5.3-6.925L87.86,119.81H84.5l7.853-8.975L84.064,100H91l4.788,6.33Zm-1.179,17.8h1.862l-12.02-15.893h-2Z",
    transform: "translate(2910.978 6518.095)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitetwitter);
export default __webpack_public_path__ + "static/media/whitetwitter.c214f7db9d22142012899cc6efeacaaf.svg";
export { ForwardRef as ReactComponent };